import React from 'react';

export const USPGrid = ({ title, description, items = [] }) => {
  if (!items || items.length === 0) return null;

  return (
    <div data-testid="usp-grid">
      <div className="text-center mb-12">
        {title && <h2 className="text-[1.6rem] md:text-3xl lg:text-4xl text-[#00224F] mb-3" style={{ fontWeight: 750 }} dangerouslySetInnerHTML={{ __html: title }}></h2>}
        {description && <div className="text-[#5A6978] max-w-2xl mx-auto text-sm md:text-base" dangerouslySetInnerHTML={{ __html: description }}></div>}
      </div>
      
      <div className="max-w-[720px] mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {items.map((item, index) => (
            <div key={index} className="group">
              {item.linkUrl ? (
                <a href={item.linkUrl} className="block relative aspect-[4/3] overflow-hidden rounded-lg">
                  <img src={item.imageUrl} alt={item.alt || `USP ${index + 1}`} className="w-full h-full object-cover" loading={index < 3 ? "eager" : "lazy"} width="240" height="180" />
                </a>
              ) : (
                <div className="relative aspect-[4/3] overflow-hidden rounded-lg">
                  <img src={item.imageUrl} alt={item.alt || `USP ${index + 1}`} className="w-full h-full object-cover" loading={index < 3 ? "eager" : "lazy"} width="240" height="180" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
